import { Helmet } from 'react-helmet-async';

// SEO configuration for O.C.A Piscine
export const SEO_CONFIG = {
    siteName: 'O.C.A Piscine',
    siteUrl: 'https://www.ocapiscine.fr',
    defaultTitle: 'O.C.A Piscine - Produits Piscine & Analyse Eau | Flayosc, Var (83)',
    defaultDescription: 'Expert en produits piscine dans le Var. Analyse d\'eau gratuite, traitement piscine, filtres à sable, produits CTX. Livraison rapide. Conseils professionnels pour l\'entretien de votre piscine.',
    defaultKeywords: 'produits piscine, piscine, filtre à sable, problème piscine, traitement eau piscine, chlore piscine, pH piscine, analyse eau piscine, entretien piscine, CTX piscine, piscine Var, piscine Flayosc, piscine Draguignan',
    locale: 'fr_FR',
    twitterHandle: '@ocapiscine',
    logo: 'https://www.ocapiscine.fr/logo.png',
};

// Page-specific SEO data
export const PAGE_SEO = {
    home: {
        title: 'O.C.A Piscine - Produits & Traitement Piscine | Expert Var (83)',
        description: 'Votre expert piscine dans le Var. Produits de traitement CTX, analyse d\'eau gratuite, filtres à sable, pompes. Livraison rapide et conseils personnalisés pour votre piscine à Draguignan, Fréjus, Saint-Raphaël.',
        keywords: 'produits piscine, traitement piscine, piscine Var, expert piscine, entretien piscine, Flayosc, Draguignan, piscine 83',
    },
    shop: {
        title: 'Boutique Produits Piscine en Ligne - CTX PRO, Filtres, Pompes | O.C.A Piscine',
        description: 'Achetez vos produits piscine en ligne : chlore lent, chlore choc, pH+, pH-, anti-algues, filtres à sable, pompes, robots. Gamme CTX PRO et O.C.A PRO. Livraison rapide France entière.',
        keywords: 'acheter produits piscine, boutique piscine en ligne, CTX piscine, chlore piscine pas cher, filtre à sable, pompe piscine, robot piscine, livraison produits piscine',
    },
    analysis: {
        title: 'Analyse Eau Piscine Gratuite en Ligne - Test pH, Chlore, TAC | O.C.A Piscine',
        description: 'Analysez l\'eau de votre piscine gratuitement en ligne. Test complet : pH, chlore, TAC, stabilisant. Recevez des recommandations personnalisées pour un traitement optimal et résolvez vos problèmes d\'eau.',
        keywords: 'analyse eau piscine gratuite, test eau piscine en ligne, pH piscine, chlore piscine, TAC piscine, eau verte piscine, problème piscine solution',
    },
    photoAnalysis: {
        title: 'Analyse Photo Piscine par IA - Diagnostic Instantané | O.C.A Piscine',
        description: 'Prenez une photo de votre piscine et obtenez un diagnostic instantané par intelligence artificielle. Détection des problèmes d\'eau verte, trouble, algues et solutions adaptées.',
        keywords: 'analyse photo piscine, diagnostic piscine IA, eau verte piscine photo, problème eau piscine diagnostic, intelligence artificielle piscine',
    },
    chat: {
        title: 'Assistant IA Piscine Lia - Conseils Entretien 24/7 | O.C.A Piscine',
        description: 'Posez vos questions sur l\'entretien de votre piscine à Lia, notre assistant IA disponible 24/7. Conseils personnalisés, solutions immédiates pour tous vos problèmes de piscine.',
        keywords: 'conseil piscine en ligne, aide piscine gratuite, problème piscine solution, entretien piscine conseils, chatbot piscine',
    },
    appointment: {
        title: 'Rendez-vous Expert Piscine Var - Devis Gratuit | O.C.A Piscine Flayosc',
        description: 'Prenez rendez-vous avec nos experts piscine à Flayosc (Var 83). Analyse d\'eau sur place, conseils personnalisés, devis gratuit. Intervention rapide Draguignan, Fréjus, Saint-Raphaël.',
        keywords: 'rendez-vous piscine Var, expert piscine 83, conseil piscine Flayosc, devis piscine gratuit, pisciniste Draguignan',
    },
    calculator: {
        title: 'Calculateur de Dosage Piscine Gratuit - Chlore, pH, Anti-Algues | O.C.A Piscine',
        description: 'Calculez gratuitement les doses exactes de produits pour votre piscine. Chlore lent, chlore choc, pH+, pH-, anti-algues, floculant. Dosage précis selon le volume de votre bassin.',
        keywords: 'calculateur dosage piscine, dose chlore piscine, quantité chlore m3, dosage pH piscine, calculateur chlore gratuit, traitement piscine dosage',
    },
    blog: {
        title: 'Conseils Piscine & Guides Entretien - Blog Expert | O.C.A Piscine',
        description: 'Découvrez nos guides et conseils d\'expert pour l\'entretien de votre piscine : traitement eau verte, filtration, hivernage, mise en route, problèmes courants et solutions.',
        keywords: 'conseils piscine, guide entretien piscine, traitement eau verte, filtre à sable entretien, hivernage piscine, problème piscine solutions',
    },
    zones: {
        title: 'Pisciniste Var (83) - Zones d\'intervention | O.C.A Piscine',
        description: 'O.C.A Piscine intervient dans tout le Var : Draguignan, Fréjus, Saint-Raphaël, Sainte-Maxime, Le Muy, Lorgues, Flayosc. Entretien, dépannage, produits piscine.',
        keywords: 'pisciniste Var, piscine Draguignan, piscine Fréjus, piscine Saint-Raphaël, entretien piscine 83, dépannage piscine Var',
    },
};

// Structured Data for Local Business
export const getLocalBusinessSchema = () => ({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.ocapiscine.fr/#business",
    "name": "O.C.A Piscine",
    "image": "https://www.ocapiscine.fr/logo.png",
    "description": "Expert en produits et entretien de piscine dans le Var. Analyse d'eau, traitement, filtres à sable, pompes et accessoires.",
    "url": "https://www.ocapiscine.fr",
    "telephone": "+33651961474",
    "email": "oca.directionpaca@gmail.com",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "5 Place de la République",
        "addressLocality": "Flayosc",
        "postalCode": "83780",
        "addressRegion": "Var",
        "addressCountry": "FR"
    },
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 43.5308,
        "longitude": 6.4081
    },
    "openingHoursSpecification": [
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "09:00",
            "closes": "12:00"
        },
        {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "16:00",
            "closes": "19:00"
        }
    ],
    "priceRange": "€€",
    "servesCuisine": "Pool Products",
    "areaServed": [
        {
            "@type": "City",
            "name": "Flayosc"
        },
        {
            "@type": "City", 
            "name": "Draguignan"
        },
        {
            "@type": "AdministrativeArea",
            "name": "Var"
        }
    ],
    "sameAs": []
});

// Structured Data for Products
export const getProductSchema = (product) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "image": product.image_url,
    "brand": {
        "@type": "Brand",
        "name": product.brand || "CTX"
    },
    "offers": {
        "@type": "Offer",
        "url": `https://www.ocapiscine.fr/shop/${product.product_id}`,
        "priceCurrency": "EUR",
        "price": product.price,
        "availability": product.stock > 0 
            ? "https://schema.org/InStock" 
            : "https://schema.org/OutOfStock",
        "seller": {
            "@type": "Organization",
            "name": "O.C.A Piscine"
        }
    },
    "category": product.category
});

// Structured Data for FAQ (for SEO)
export const getFAQSchema = () => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
        {
            "@type": "Question",
            "name": "Comment analyser l'eau de ma piscine ?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Utilisez notre outil d'analyse en ligne gratuit. Entrez vos valeurs de pH, chlore et TAC, et recevez des recommandations personnalisées pour le traitement de votre piscine."
            }
        },
        {
            "@type": "Question",
            "name": "Comment résoudre un problème d'eau verte dans ma piscine ?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "L'eau verte est généralement causée par des algues. Vérifiez d'abord le pH (idéalement entre 7.0 et 7.4), effectuez un traitement choc au chlore, puis utilisez un anti-algues. Nettoyez le filtre à sable et faites tourner la filtration 24h."
            }
        },
        {
            "@type": "Question",
            "name": "À quelle fréquence dois-je nettoyer mon filtre à sable ?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Effectuez un contre-lavage (backwash) de votre filtre à sable toutes les 1 à 2 semaines pendant la saison de baignade, ou lorsque la pression du manomètre augmente de 0.5 bar par rapport à la normale."
            }
        },
        {
            "@type": "Question",
            "name": "Quels produits utiliser pour l'entretien de ma piscine ?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Pour un entretien régulier, vous aurez besoin de : chlore (galets ou liquide), correcteur de pH (pH+ ou pH-), anti-algues préventif, et floculant. Découvrez notre gamme CTX adaptée à tous les types de piscines."
            }
        }
    ]
});

// Structured Data for Website
export const getWebsiteSchema = () => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "O.C.A Piscine",
    "url": "https://www.ocapiscine.fr",
    "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.ocapiscine.fr/shop?search={search_term_string}",
        "query-input": "required name=search_term_string"
    }
});

// SEO Component
export function SEOHead({ 
    title, 
    description, 
    keywords, 
    canonicalUrl,
    ogImage,
    ogType = 'website',
    structuredData = []
}) {
    const fullTitle = title || SEO_CONFIG.defaultTitle;
    const fullDescription = description || SEO_CONFIG.defaultDescription;
    const fullKeywords = keywords || SEO_CONFIG.defaultKeywords;
    const canonical = canonicalUrl || SEO_CONFIG.siteUrl;
    const image = ogImage || SEO_CONFIG.logo;

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={fullDescription} />
            <meta name="keywords" content={fullKeywords} />
            <meta name="author" content="O.C.A Piscine" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="French" />
            <meta name="revisit-after" content="7 days" />
            <link rel="canonical" href={canonical} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={ogType} />
            <meta property="og:url" content={canonical} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={fullDescription} />
            <meta property="og:image" content={image} />
            <meta property="og:locale" content={SEO_CONFIG.locale} />
            <meta property="og:site_name" content={SEO_CONFIG.siteName} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={canonical} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={fullDescription} />
            <meta name="twitter:image" content={image} />

            {/* Geo Tags for Local SEO */}
            <meta name="geo.region" content="FR-83" />
            <meta name="geo.placename" content="Flayosc" />
            <meta name="geo.position" content="43.5308;6.4081" />
            <meta name="ICBM" content="43.5308, 6.4081" />

            {/* Structured Data */}
            {structuredData.map((data, index) => (
                <script key={index} type="application/ld+json">
                    {JSON.stringify(data)}
                </script>
            ))}
        </Helmet>
    );
}

export default SEOHead;
